import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'

export function useGetWorkflowStatus({ companyId }: { companyId: string }) {
  return useQuery({
    queryKey: ['workflow-statuses', companyId],
    queryFn: async () => {
      const response = await axios.get(`workflow-statuses`, {
        params: {
          company_id: companyId,
        },
      })
      return response.data.data as WorkflowStatus[]
    },
  })
}
